export default __webpack_public_path__ + "static/media/document.82832629.png";